// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2KUQk","imageUploader":"EGiftCard_imageUploader__HvDfC"};